import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import pick from 'lodash/pick';
import { currentUserSelector } from '../../reducers/selectors'

const mapStateToProps = state => ({ user: currentUserSelector(state) });

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ }, dispatch);
};

class Intercom extends Component {
  
  isLibInitialised (){
    return typeof window.Intercom !== 'undefined' && window.Intercom
  }
  
  getUserProps (user){
    if (!user || !user.id )
      return {}
    
    return {...pick(user, ['email', 'name', 'created_at', 'trial_by', 'user_id', 'ref', 'fte_completed', 'generated_pw']), user_id: user.id, user_hash: user.intercom_user_hash}
  }
  
  
  initIntercom (props){
    const { appId } = props;
    if (!this.isLibInitialised() || typeof appId === 'undefined')
      return
    
    const initData = {app_id: appId, ...(this.getUserProps(props.user))}
    
    if (process.env.NODE_ENV !== 'production')
      return console.log("Intercom boot", initData)
    
    window.Intercom("boot", initData);
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user) {
      window.Intercom('shutdown')
      this.initIntercom(nextProps)
    }
  }
  
  componentWillMount() {
    this.initIntercom(this.props)
  }
  
  render() {
    return null
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(Intercom);


// WEBPACK FOOTER //
// ./src/components/counters/Intercom.js